
<b-navbar variant="light" type="light" fixed="top" toggleable="lg">
  <b-navbar-brand :to="{ path: '/home' }">
    <img :src="logoUrl" style="height:30px" alt="home">
  </b-navbar-brand>
  <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
  <b-collapse is-nav id="nav_collapse">
    <b-navbar-nav>
      <b-nav-item :to="{name:'product_category_selection_path', params: {}}">Products</b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav>
      <b-nav-item :to="{name:'part_search_path'}">Part Search</b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav>
      <b-nav-item :to="{name:'quote_path'}">Quote Summary</b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav>
      <b-nav-item @click="handleNewQuote" >New Quote</b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
      <b-navbar-nav>
        <b-nav-item @click="handleSignOut" >Sign In</b-nav-item>
      </b-navbar-nav>
    </b-navbar-nav>
  </b-collapse>
</b-navbar>
